import script from "./InformationManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./InformationManagement.vue?vue&type=script&setup=true&lang=js"

import "./InformationManagement.vue?vue&type=style&index=0&id=f52f5238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f52f5238"]])

export default __exports__